import React from "react";
import { Outlet } from "react-router";

function Loan() {
  return (
    <div className="p-4">
      <Outlet />
    </div>
  );
}

export default Loan;
